import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TcPerfilUsuarioEnum } from '../../_infrastructure/types/common';
import { ComponentBase } from '../../_infrastructure/classes/componentBase';
import { AuthService } from '../../_infrastructure/classes/services/auth.service';
import { AlertaRechazoService } from './alertaRechazo.service';
import {
    AlertaMatriculaRechazadaViewModel,
    AlertaProductoRechazadoExViewModel,
    AlertaProductoRechazadoViewModel,
    CambioPcfViewModel,
} from './alertaRechazo.types';
import { ConfigurationService } from '../../_infrastructure/classes/services/configuration.service';
import { NotificationService } from '../../_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../_infrastructure/classes/handlers/exceptionManager';
import { SolicitudExRelacionAtestacionesViewModel } from '../../../_exportacion/solicitudes/relacionatestaciones/relacionatestaciones.types';
import { TClaveSolicitudAtestFitoViewModel } from '../../../_exportacion/atestaciones/datosbasicos/datosbasicosAtestFito.types';
import {
    EnumIdsTcEstadoCertificadoFitoEx,
    EnumIdsTcEstadoSolicitudEx,
    EnumIdsTwTcSubTipoSolicitudEx,
    EnumTipoReasignacion,
    EnumTipoReasignacionAbrev,
} from '../../../_exportacion/solicitudes/types/enum';
import { EnumIdsTcEstadoSolicitud, EnumIdsTcTipoSolicitud, EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudExViewModel } from '../../../_exportacion/solicitudes/datosbasicos/datosbasicosEx.types';
import { SolicitudExService } from '../../../_exportacion/solicitudes/datosbasicos/datosbasicosEx.service';
import { SolicitudViewModel } from '../../../_importacion/solicitudes/datosbasicos/datosbasicos.types';

@Component({
    selector: 'app-alertarechazo',
    templateUrl: './alertaRechazo.component.html',
    styleUrls: ['./alertaRechazo.component.scss'],
})
export class AlertaRechazoComponent extends ComponentBase implements OnInit, OnChanges {
    @Input() id: number;
    @Input() esImport: boolean;
    @Input() esExport: boolean;

    solicitudLigeraImpor: SolicitudViewModel | null;
    solicitudLigeraExpor: SolicitudExViewModel | null;
    rechazo: AlertaProductoRechazadoViewModel | undefined;
    rechazoEx: AlertaProductoRechazadoExViewModel | undefined;
    rechazosMat: AlertaMatriculaRechazadaViewModel[] = [];
    matriculas: AlertaMatriculaRechazadaViewModel[] = [];
    relacionAtestaciones: SolicitudExRelacionAtestacionesViewModel;
    claveSolicitudAtestFitoCollection: TClaveSolicitudAtestFitoViewModel[] = [];
    solicitudesHijasRechazoParcialCollection: SolicitudViewModel[] = [];
    solicitudPadreRechazoParcial: SolicitudViewModel;
    solicitudEx: SolicitudExViewModel;
    solicitudPadreAnulSust: SolicitudExViewModel;
    solicitudTrasladoPadre: SolicitudViewModel;
    solicitudNormalHija: SolicitudViewModel;
    mensajeSolicitudAnulSust = '';

    environment: string;

    arrayCodigosPorMatriculaRechazada: Map<string, AlertaMatriculaRechazadaViewModel[]> = new Map<string, AlertaMatriculaRechazadaViewModel[]>();
    arrayCodigosPorMatricula: Map<string, AlertaMatriculaRechazadaViewModel[]> = new Map<string, AlertaMatriculaRechazadaViewModel[]>();

    //idEstadoSolicitud: number;
    //idEstadoSolicitudEx: number;

    totalCountAvisos = 0;
    totalCountRechazos = 0;
    totalCountRechazosEx = 0;
    totalCountEnlaces = 0;

    hayAtestaciones = false;
    haySolAnulSust = false;
    haySolHijaRechazoParcial = false;
    haySolPadreRechazoParcial = false;
    haySolTrasladoPadre = false;
    haySolHijaNormal = false;

    isCollapsedAvisos = true;
    isCollapsedRechazos = true;
    isCollapsedEnlaces = true;

    cambioPcf: CambioPcfViewModel[] = [];

    constructor(
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private router: Router,
        private alertaRechazoService: AlertaRechazoService,
        protected configurationService: ConfigurationService,
        private solicitudExService: SolicitudExService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.configurationService.getEnvironment().subscribe(res => {
            this.environment = res;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.id?.currentValue) {
            this.getAlertas();
        }
    }

    private includeIfNotExistsRechazada(rechazo: AlertaMatriculaRechazadaViewModel): void {
        let found: AlertaMatriculaRechazadaViewModel | undefined = undefined;
        let arrRechazosByMatricula: AlertaMatriculaRechazadaViewModel[];

        if (this.arrayCodigosPorMatriculaRechazada.has(rechazo.Matricula)) {
            arrRechazosByMatricula = this.arrayCodigosPorMatriculaRechazada.get(rechazo.Matricula)!;
            found = arrRechazosByMatricula?.find(x => x.Codigo === rechazo.Codigo);
            if (found === undefined) {
                arrRechazosByMatricula?.push(rechazo);
            }
        } else {
            arrRechazosByMatricula = [rechazo];
        }
        if (found === undefined) {
            this.arrayCodigosPorMatriculaRechazada.set(rechazo.Matricula, arrRechazosByMatricula!);
        }
    }

    private includeIfNotExists(rechazo: AlertaMatriculaRechazadaViewModel): void {
        let found: AlertaMatriculaRechazadaViewModel | undefined = undefined;
        let arrRechazosByMatricula: AlertaMatriculaRechazadaViewModel[];

        if (this.arrayCodigosPorMatricula.has(rechazo.Matricula)) {
            arrRechazosByMatricula = this.arrayCodigosPorMatricula.get(rechazo.Matricula)!;
            found = arrRechazosByMatricula?.find(x => x.Codigo === rechazo.Codigo);
            if (found === undefined) {
                arrRechazosByMatricula?.push(rechazo);
            }
        } else {
            arrRechazosByMatricula = [rechazo];
        }
        if (found === undefined) {
            this.arrayCodigosPorMatricula.set(rechazo.Matricula, arrRechazosByMatricula!);
        }
    }

    private getAlertas() {
        if (this.esImport) {
            // Consulto la solicitud de IMPORTACIÓN
            this.alertaRechazoService.getSolicitudById(this.id).subscribe(res => {
                if (res != null) {
                    this.solicitudLigeraImpor = res;

                    if (this.solicitudLigeraImpor != null) {
                        if (this.isInspector) {
                            // Productos ("similares") rechazados en otras solicitudes de Importación
                            const alertasImp = this.alertaRechazoService.getAlertasProdImp(this.id);
                            if (alertasImp == null) {
                                this.alertaRechazoService.getProductosSolicitudRechazados(this.id).subscribe(res => {
                                    if (res != null) {
                                        this.rechazo = res;
                                        this.alertaRechazoService.setAlertasProdImp(res, this.id);
                                        this.totalCountRechazos++;
                                    }
                                });
                            } else {
                                this.rechazo = alertasImp;
                                this.totalCountRechazos++;
                            }
                        }

                        if (this.isInspector) {
                            // Matrículas ya rechazadas en otras solicitudes
                            const alertasMatRechazadas = this.alertaRechazoService.getAlertasMatImpRechazadas(this.id);
                            if (alertasMatRechazadas.length == 0) {
                                this.alertaRechazoService.getMatriculasRechazadas(this.id).subscribe(res => {
                                    if (res != null) {
                                        this.rechazosMat = res;
                                        this.alertaRechazoService.setAlertasMatImpRechazadas(res, this.id);

                                        this.rechazosMat.forEach(rechazo => {
                                            this.includeIfNotExistsRechazada(rechazo);
                                            this.totalCountRechazos++;
                                        });
                                    }
                                });
                            } else {
                                this.rechazosMat = alertasMatRechazadas;
                                this.rechazosMat.forEach(rechazo => {
                                    this.includeIfNotExistsRechazada(rechazo);
                                    this.totalCountRechazos++;
                                });
                            }
                        }
                        if (this.isInspector) {
                            // Matrículas que NO han sido aún rechazadas en otras solicitudes pero aparecen en ellas
                            const alertasMat = this.alertaRechazoService.getAlertasMatImp(this.id);
                            if (alertasMat.length == 0) {
                                this.alertaRechazoService.getMatriculas(this.id).subscribe(res => {
                                    if (res != null) {
                                        this.matriculas = res;
                                        this.alertaRechazoService.setAlertasMatImp(res, this.id);

                                        this.matriculas.forEach(matricula => {
                                            this.includeIfNotExists(matricula);
                                            this.totalCountAvisos++;
                                        });
                                    }
                                });
                            } else {
                                this.matriculas = alertasMat;
                                this.matriculas.forEach(matricula => {
                                    this.includeIfNotExists(matricula);
                                    this.totalCountAvisos++;
                                });
                            }
                        }

                        if (this.isInspector || this.isSolicitante || this.isGrabador || this.isConsultas) {
                            //se comprueba el reseteo de las solicitudes hijas
                            this.alertaRechazoService.resetHijasRechazoParcial(this.id);
                            if (this.solicitudLigeraImpor.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_RECHAZADA_PARCIALMENTE) {
                                // Rechazos Parciales Hijas
                                const solicitudesHijas = this.alertaRechazoService.getHijasRechazoParcial(this.id);
                                if (solicitudesHijas == null || solicitudesHijas.length == 0) {
                                    this.alertaRechazoService.getSolicitudesJerarquiaByIdPadre(this.id).subscribe(res => {
                                        this.solicitudesHijasRechazoParcialCollection = res;

                                        if (this.solicitudesHijasRechazoParcialCollection.length !== 0) {
                                            this.haySolHijaRechazoParcial = true;
                                            this.alertaRechazoService.setHijasRechazoParcial(this.solicitudesHijasRechazoParcialCollection, this.id);
                                        } else {
                                            this.alertaRechazoService.setHijasRechazoParcial([], this.id);
                                        }
                                        this.totalCountEnlaces += this.solicitudesHijasRechazoParcialCollection.length;
                                    });
                                } else {
                                    this.solicitudesHijasRechazoParcialCollection = solicitudesHijas;
                                    this.haySolHijaRechazoParcial = true;
                                    this.totalCountEnlaces += this.solicitudesHijasRechazoParcialCollection.length;
                                }
                            }

                            if (
                                this.solicitudLigeraImpor.TwSolicitudJerarquia != null &&
                                this.solicitudLigeraImpor.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_PARTICION
                            ) {
                                // Rechazo Parcial Padre
                                const solicitudPadre = this.alertaRechazoService.getPadreRechazoParcial(this.id);
                                if (solicitudPadre == null) {
                                    this.alertaRechazoService.getSolicitudPadreJerarquiaById(this.id).subscribe(res => {
                                        if (res != null) {
                                            this.haySolPadreRechazoParcial = true;
                                            this.solicitudPadreRechazoParcial = res;
                                            this.alertaRechazoService.setPadreRechazoParcial(res, this.id);
                                            this.totalCountEnlaces++;
                                        }
                                    });
                                } else {
                                    this.solicitudPadreRechazoParcial = solicitudPadre;
                                    this.haySolPadreRechazoParcial = true;
                                    this.totalCountEnlaces++;
                                }
                            } else if (
                                this.solicitudLigeraImpor.TwSolicitudJerarquia != null &&
                                this.solicitudLigeraImpor.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_NORMAL &&
                                this.solicitudLigeraImpor.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_FINALIZA_TRASLADO
                            ) {
                                // Solicitud Padre de tipo "Traslado"
                                const solicitudTrasladoPadre = this.alertaRechazoService.getTrasladoPadre(this.id);
                                if (solicitudTrasladoPadre == null) {
                                    this.alertaRechazoService.getSolicitudTrasladoPadreJerarquiaById(this.id).subscribe(res => {
                                        if (res != null) {
                                            this.haySolTrasladoPadre = true;
                                            this.solicitudTrasladoPadre = res;
                                            this.alertaRechazoService.setTrasladoPadre(res, this.id);
                                            this.totalCountEnlaces++;
                                        }
                                    });
                                } else {
                                    this.solicitudTrasladoPadre = solicitudTrasladoPadre;
                                    this.haySolTrasladoPadre = true;
                                    this.totalCountEnlaces++;
                                }
                            } else if (this.solicitudLigeraImpor.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRASLADO) {
                                // Solicitud Hija de tipo "Normal"
                                const solicitudNormalHija = this.alertaRechazoService.getNormalHija(this.id);
                                if (solicitudNormalHija == null || solicitudNormalHija == undefined) {
                                    this.alertaRechazoService.getSolicitudNormalHijaJerarquiaById(this.id).subscribe(res => {
                                        if (res != null && this.solicitudLigeraImpor?.TwTraslado.Finalizado === true) {
                                            this.haySolHijaNormal = true;
                                            this.solicitudNormalHija = res;
                                            this.alertaRechazoService.setNormalHija(res, this.id);
                                            this.totalCountEnlaces++;
                                        }
                                    });
                                } else {
                                    this.solicitudNormalHija = solicitudNormalHija;
                                    this.haySolHijaNormal = true;
                                    this.totalCountEnlaces++;
                                }
                            }
                        }
                    }
                }
            });
        } else if (this.esExport) {
            this.totalCountRechazosEx = 0;
            this.mensajeSolicitudAnulSust = '';

            // Consulto la solicitud de EXPORTACIÓN
            this.alertaRechazoService.getSolicitudExById(this.id).subscribe(res => {
                if (res != null) {
                    this.solicitudLigeraExpor = res;

                    if (this.solicitudLigeraExpor != null) {
                        if (this.isInspector) {
                            // Productos ("similares") rechazados en otras solicitudes de Exportación
                            const alertasExp = this.alertaRechazoService.getAlertasProdExp(this.id);
                            if (alertasExp == null) {
                                this.alertaRechazoService.getProductosSolicitudExRechazados(this.id).subscribe(res => {
                                    if (res != null) {
                                        this.rechazoEx = res;
                                        this.alertaRechazoService.setAlertasProdExp(res, this.id);
                                        this.totalCountRechazosEx++;
                                    }
                                });
                            } else {
                                this.rechazoEx = alertasExp;
                                this.totalCountRechazosEx++;
                            }
                        }

                        if (this.isInspector || this.isSolicitante) {
                            this.alertaRechazoService.validarCambioPcf(this.id).subscribe(val => {
                                if (val != null) {
                                    this.cambioPcf = val;
                                    this.totalCountAvisos += this.cambioPcf.length;
                                }
                            });
                        }

                        if (
                            this.solicitudLigeraExpor.IdSubTipoSolicitudEx === EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO ||
                            EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO ||
                            EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO
                        ) {
                            if (this.isInspector || this.isCoordinador || this.isSolicitante || this.isCA) {
                                // Atestaciones
                                const atestaciones = this.alertaRechazoService.getAtestaciones(this.id);
                                if (atestaciones.length == 0) {
                                    this.alertaRechazoService.getRelacionatestaciones(this.id).subscribe(res => {
                                        this.relacionAtestaciones = res;

                                        for (let i = 0; i < this.relacionAtestaciones.TSolicitudAtestFitoSolicitudExCollection.length; i++) {
                                            this.claveSolicitudAtestFitoCollection = [
                                                ...this.claveSolicitudAtestFitoCollection,
                                                this.relacionAtestaciones.TSolicitudAtestFitoSolicitudExCollection[i].TSolicitudAtestFito
                                                    .TClaveSolicitudAtestFito,
                                            ];
                                        }

                                        if (this.claveSolicitudAtestFitoCollection.length !== 0) {
                                            this.hayAtestaciones = true;
                                            this.alertaRechazoService.setAtestaciones(this.claveSolicitudAtestFitoCollection, this.id);
                                        } else {
                                            this.alertaRechazoService.setAtestaciones([], this.id);
                                        }

                                        this.totalCountEnlaces += this.claveSolicitudAtestFitoCollection.length;
                                    });
                                } else {
                                    this.hayAtestaciones = true;
                                    this.claveSolicitudAtestFitoCollection = atestaciones;
                                    this.totalCountEnlaces += this.claveSolicitudAtestFitoCollection.length;
                                }
                            }
                        }
                    }

                    // Solicitudes Anul/Sust
                    const solAnulSust = this.alertaRechazoService.getSolAnulSust(this.id);
                    if (solAnulSust == null || solAnulSust.model === undefined) {
                        this.alertaRechazoService.getSolicitudExConJerarquiaById(this.id).subscribe(res => {
                            this.solicitudEx = res;
                            // Si la solicitud no está anulada y es CLONADA por Anulación y Sustitución se obtiene la solicitud Padre
                            if (
                                this.solicitudEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_ANULADA &&
                                this.solicitudEx.TwSolicitudJerarquiaEx != null &&
                                this.solicitudEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_ANULACION_SUSTITUCION
                            ) {
                                this.solicitudExService.getSolicitudSolo(this.solicitudEx.TwSolicitudJerarquiaEx.IdSolicitudPadre).subscribe(res => {
                                    this.solicitudPadreAnulSust = res;
                                    this.mensajeSolicitudAnulSust = 'Anula y sustituye al CF Nº';
                                    this.alertaRechazoService.setSolAnulSust(res, this.id, this.mensajeSolicitudAnulSust);
                                    this.haySolAnulSust = true;
                                    this.totalCountEnlaces++;
                                });
                            }
                            // Si estamos en la solicitud Padre con ePhyto Anulado y Sustituido por otro, también lanzar el enlace con el mensaje informativo sobre la solicitud hija que le ha anulado y sustituido
                            else if (
                                this.solicitudEx.TwSolicitudJerarquiaEx != null &&
                                this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_ANULADO_SUSTITUIDO
                            ) {
                                this.solicitudExService.getSolicitudAnulaSustituyeSolicitudPadreByIdPadre(this.id).subscribe(res => {
                                    this.solicitudPadreAnulSust = res; // Realmente es hija, pero no vamos a crear otra variable por el nombre sólo
                                    this.mensajeSolicitudAnulSust = 'Anulada y sustituida por el CF Nº';
                                    this.alertaRechazoService.setSolAnulSust(res, this.id, this.mensajeSolicitudAnulSust);
                                    this.haySolAnulSust = true;
                                    this.totalCountEnlaces++;
                                });
                            } else {
                                // Se vacía la anulación y sustitución porque si no da problemas al cambiar de solicitud. 27062024
                                this.haySolAnulSust = false;
                                this.alertaRechazoService.setSolAnulSust(new SolicitudExViewModel(), 0, '');
                            }
                        });
                    } else {
                        if (solAnulSust.model.Id > 0) {
                            this.haySolAnulSust = true;
                            this.solicitudPadreAnulSust = solAnulSust.model!;
                            this.mensajeSolicitudAnulSust = solAnulSust.msj;
                            this.totalCountEnlaces++;
                        }
                    }
                }
            });
        }
    }

    get showEnlaces(): boolean {
        return (
            this.claveSolicitudAtestFitoCollection?.length !== 0 ||
            this.mensajeSolicitudAnulSust !== '' ||
            this.solicitudesHijasRechazoParcialCollection?.length !== 0 ||
            this.haySolPadreRechazoParcial ||
            this.haySolTrasladoPadre ||
            this.haySolHijaNormal
        );
    }

    redirectImport(idSolicitud: number): void {
        let url;
        let cexvegweb = '';

        if (this.environment !== 'Desarrollo' && this.environment !== 'Tragsatec') {
            cexvegweb = 'cexvegweb';
        }

        if (this.esImport) {
            url = this.router.serializeUrl(this.router.createUrlTree([cexvegweb + '/importacion/solicitud/datosbasicos/', idSolicitud]));
        }

        window.open(url, '_blank');
    }

    redirectExport(idSolicitudEx: number): void {
        let url;
        let cexvegweb = '';

        if (this.environment !== 'Desarrollo' && this.environment !== 'Tragsatec') {
            cexvegweb = 'cexvegweb';
        }

        if (this.esExport) {
            url = this.router.serializeUrl(this.router.createUrlTree([cexvegweb + '/exportacion/solicitud/datosbasicosEx/', idSolicitudEx]));
        }

        window.open(url, '_blank');
    }

    redirectAtestaciones(idSolicitudEx: number): void {
        let url;
        let cexvegweb = '';

        if (this.environment !== 'Desarrollo' && this.environment !== 'Tragsatec') {
            cexvegweb = 'cexvegweb';
        }

        if (this.hayAtestaciones) {
            url = this.router.serializeUrl(this.router.createUrlTree([cexvegweb + '/exportacion/atestacion/datosbasicos', idSolicitudEx]));
        }

        window.open(url, '_blank');
    }

    redirectSolAnulSust(): void {
        let url;
        let cexvegweb = '';

        if (this.environment !== 'Desarrollo' && this.environment !== 'Tragsatec') {
            cexvegweb = 'cexvegweb';
        }

        if (this.haySolAnulSust) {
            url = this.router.serializeUrl(this.router.createUrlTree([cexvegweb + '/exportacion/solicitud/datosbasicosEx/' + this.solicitudPadreAnulSust.Id]));
        }

        window.open(url, '_blank');
    }

    redirectSolHijasRechazoParcial(idSolicitud: number): void {
        let url;
        let cexvegweb = '';

        if (this.environment !== 'Desarrollo' && this.environment !== 'Tragsatec') {
            cexvegweb = 'cexvegweb';
        }

        if (this.haySolHijaRechazoParcial) {
            url = this.router.serializeUrl(this.router.createUrlTree([cexvegweb + '/importacion/solicitud/datosbasicos/', idSolicitud]));
        }

        window.open(url, '_blank');
    }

    redirectSolPadreRechazoParcial(idSolicitud: number): void {
        let url;
        let cexvegweb = '';

        if (this.environment !== 'Desarrollo' && this.environment !== 'Tragsatec') {
            cexvegweb = 'cexvegweb';
        }

        if (this.haySolPadreRechazoParcial) {
            url = this.router.serializeUrl(this.router.createUrlTree([cexvegweb + '/importacion/solicitud/datosbasicos/', idSolicitud]));
        }

        window.open(url, '_blank');
    }

    redirectSolTrasladoPadre(idSolicitud: number): void {
        let url;
        let cexvegweb = '';

        if (this.environment !== 'Desarrollo' && this.environment !== 'Tragsatec') {
            cexvegweb = 'cexvegweb';
        }

        if (this.haySolTrasladoPadre) {
            url = this.router.serializeUrl(this.router.createUrlTree([cexvegweb + '/importacion/solicitud/datosbasicos/', idSolicitud]));
        }

        window.open(url, '_blank');
    }

    redirectSolNormalHija(idSolicitud: number): void {
        let url;
        let cexvegweb = '';

        if (this.environment !== 'Desarrollo' && this.environment !== 'Tragsatec') {
            cexvegweb = 'cexvegweb';
        }

        if (this.haySolHijaNormal) {
            url = this.router.serializeUrl(this.router.createUrlTree([cexvegweb + '/importacion/solicitud/datosbasicos/', idSolicitud]));
        }

        window.open(url, '_blank');
    }

    isCollapsed(value: boolean): void {
        this.isCollapsedAvisos = this.isCollapsedRechazos = this.isCollapsedEnlaces = value;
    }

    getModoReasignacion(item: CambioPcfViewModel): string {
        let modo = '';

        if (item.ModoReasignacion === EnumTipoReasignacionAbrev.MANUAL) {
            modo = EnumTipoReasignacion.MAN;
        } else if (item.ModoReasignacion === EnumTipoReasignacionAbrev.AUTOMAT) {
            modo = EnumTipoReasignacion.AUT;
        } else if (item.ModoReasignacion === EnumTipoReasignacionAbrev.SISTEMA) {
            modo = EnumTipoReasignacion.SIS;
        }
        return modo;
    }
}
